import { ElementType } from "../../../../library-js/dom-tools/ElementType";
import { ReminderData } from "./app/data/ReminderData";
import { ReminderApp } from "./app/ReminderApp";
import { ReminderUI } from "./ui/reminder-ui";

export class ReminderUIElement
{
  static applyOnDocument()
  {
    ReminderUI.type.forAllInDoc( e => ReminderUIElement.applyOnElement( e ) );
  }

  static async applyOnElement( e:Element )
  { 
    let reminderApp = new ReminderApp();

    await reminderApp.start( e );

    reminderApp.ensureData();
   
    reminderApp.root.setApp( reminderApp );

    return Promise.resolve();
  }
}